import React from "react";
import {
  FormControl,
  FormControlLabel,
  FormGroup,
  Grid,
  Checkbox,
} from "@mui/material";
import styled from "styled-components";
import { CheckedIconMapper, IconMapper } from "../../../constants/WebMap";

const StyledGridTitle = styled(Grid)`
  margin-bottom: 10px !important;
  text-align: left;
  font: normal normal 550 13px/18px Open Sans;
  color: black;
`;

const CommonHorizMultiSelect = ({ data = [], handleChange, icon = false, title, multiLineLabel = false }) => {
  const bpx = multiLineLabel ? "16px" : "12px"; // border curve in px
  return (
    <>
      <FormControl style={{ width: "100%" }}>
        <StyledGridTitle item xs={12} sm={12} md={12}>
          {title}
        </StyledGridTitle>
        <FormGroup
          row
          aria-labelledby={"form-group-horizontal"}
          name={"radio-group-horizontal"}
          style={{ width: "100%", display: "flex" }}
        >
          {data.map((item, idx) => (
            <FormControlLabel
              key={idx}
              value={item.filterName}
              sx={{
                m: 0,
                flex: 1,
                minHeight: "20px",
                display: "flex",
                justifyContent: "center",
                ...(item.isChecked && {
                  backgroundColor: "#007842",
                  color: "white",
                }),
                borderRadius: `${idx === 0 && idx === data.length - 1
                  ? `${bpx} ${bpx} ${bpx} ${bpx}`
                  : idx === 0
                    ? `${bpx} 0px 0px ${bpx}`
                    : idx === data.length - 1 && `0px ${bpx} ${bpx} 0px`
                  }`,
                border: `1px solid ${item.isChecked && (idx !== data.length - 1) && data[idx + 1].isChecked ? "rgba(255, 255, 255, 0.5)" : "rgba(0, 120, 66, 0.5)"}`,
                ".MuiFormControlLabel-label": {
                  fontSize: 13,
                },
              }}
              disabled={item.disabled}
              control={
                <Checkbox
                  checked={item.isChecked}
                  onChange={() => handleChange(item)}
                  name={item.filterName}
                  sx={{ display: "none" }}
                />
              }
              label={
                icon ? (
                  <div
                    style={{
                      height: "15px",
                      textAlign: "center",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      margin: "2px 0px",
                    }}
                  >
                    {IconMapper[`${item.label}`] && (
                      <img
                        src={
                          item.isChecked
                            ? CheckedIconMapper[`${item.label}`]
                            : IconMapper[`${item.label}`]
                        }
                        alt={item.label}
                        style={{ maxWidth: "100%", maxHeight: "100%" }}
                        vertical-align="middle"
                      />
                    )}
                    {!IconMapper[`${item.label}`] && (
                      <span style={{ wordBreak: "break-word" }}>
                        {" "}
                        {item.label}{" "}
                      </span>
                    )}
                  </div>
                ) : (
                  <div
                    style={{
                      textAlign: "center",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <span
                      style={{
                        ...(!multiLineLabel ? {
                          overflow: "hidden",
                          whiteSpace: "nowrap",
                          textOverflow: "ellipsis",
                          maxWidth: "50px",
                        } : {
                          padding: "2px 0px"
                        }),
                        fontSize: "10px",
                      }}
                    >
                      {" "}
                      {item.label}{" "}
                    </span>
                  </div>
                )
              }
            />
          ))}
        </FormGroup>
      </FormControl>
    </>
  );
};

export default CommonHorizMultiSelect;
